import styled from '@emotion/styled';
import PolarisIcon from '../_common/PolarisIcon';

type PriorityNumberProps = {
  priority: number;
  className?: string;
};

const PriorityNumber = ({ priority, className = '' }: PriorityNumberProps) => (
  <Priority className={className}>
    <PolarisIcon icon="priority" height={20} />
    {priority}
  </Priority>
);

export default PriorityNumber;

const Priority = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;

  & svg {
    color: ${({ theme }) => theme.palette.warning.light};
    margin-right: 4px;
    animation: pulse2 1.25s ease-in-out infinite alternate;
  }
`;
